import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { getAllWronglyAssignedKits, getKits, getTestSummary } from '../../view.updater/actions/dashboard.actions';
import { makeSelectDashboardKits, makeSelectTestSummary, makeSelectWronglyAssignedKits } from '../../view.updater/selectors/dashboard.selectors';
import ViewWronglyAssignedKits from './view.wrongly.assigned.kits';

const mapDispatchToProps = (dispatch) => ({
    getKits: (data) => dispatch(getKits(data)),
    getTestSummary: () => dispatch(getTestSummary()),
    getAllWronglyAssignedKits: (data) => dispatch(getAllWronglyAssignedKits(data))
});

const mapStateToProps = createStructuredSelector({
    kits: makeSelectDashboardKits(),
    testSummary: makeSelectTestSummary(),
    wronglyAssignedKits: makeSelectWronglyAssignedKits(),
});
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ViewWronglyAssignedKits);